import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useProducts } from '../contexts/ProductContext';
import { useCart } from '../contexts/CartContext';
import { useAuth } from '../contexts/AuthContext';
import { FaArrowLeft, FaMinus, FaPlus } from 'react-icons/fa';

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { getProductById } = useProducts();
  const { addToCart, getCartItem } = useCart();
  const { user } = useAuth();
  
  const [quantity, setQuantity] = useState(1);
  
  const product = getProductById(id);
  const cartItem = getCartItem(id);

  if (!user) {
    return (
      <div className="container text-center mt-5">
        <h2>Please login to view product details</h2>
        <button onClick={() => navigate('/login')} className="btn btn-primary">
          Login
        </button>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="container text-center mt-5">
        <h2>Product not found</h2>
        <button onClick={() => navigate('/products')} className="btn btn-primary">
          Back to Products
        </button>
      </div>
    );
  }

  const handleQuantityChange = (newQuantity) => {
    if (newQuantity >= 1) {
      setQuantity(newQuantity);
    }
  };

  const handleAddToCart = () => {
    addToCart(product, quantity);
    setQuantity(1);
  };

  return (
    <div className="product-detail-bg">
      <div className="product-detail-card">
        {/* Back Button */}
        <button className="back-btn" onClick={() => navigate('/products')} aria-label="Back to Products">
          <FaArrowLeft />
        </button>
        {/* Product Image */}
        <img src={product.image} alt={product.name} className="product-detail-img" />
        {/* Name & Badge */}
        <div className="d-flex align-items-center mb-2 mt-3" style={{ gap: 8 }}>
          <h2 className="product-title mb-0">{product.name}</h2>
        </div>
        {/* Price & In Cart */}
        <div className="d-flex align-items-center mb-2" style={{ gap: 8 }}>
          <span className="product-price">₹{product.price}</span>
          {cartItem && (
            <span className="in-cart-pill">{cartItem.quantity} in cart</span>
          )}
        </div>
        {/* Description */}
        <div className="product-desc mb-3">{product.description}</div>
        {/* Quantity Controls */}
        <div className="mb-3">
          <label className="form-label d-block mb-2" style={{ fontWeight: 500 }}>Quantity:</label>
          <div className="d-flex align-items-center gap-3 justify-content-center">
            <button className="quantity-btn" onClick={() => handleQuantityChange(quantity - 1)} disabled={quantity <= 1}><FaMinus /></button>
            <span className="h5 mb-0" style={{ minWidth: '40px', textAlign: 'center', fontWeight: 600 }}>{quantity}</span>
            <button className="quantity-btn" onClick={() => handleQuantityChange(quantity + 1)}><FaPlus /></button>
          </div>
        </div>
        {/* Action Buttons */}
        <div className="d-grid gap-2 mt-3">
          <button onClick={handleAddToCart} className="action-btn primary">Add to Cart - ₹{(product.price * quantity).toFixed(2)}</button>
          <button onClick={() => navigate('/cart')} className="action-btn outline">View Cart</button>
        </div>
      </div>
    </div>
  );
};

export default ProductDetail; 